import { Logger, LoggerService } from '@Shared/logger';
import { Template } from '.';
import { UIModule } from '../ui.module';
import Modal from 'bootstrap/js/dist/modal';
import { UI_CONST } from '../display';
import { OptionsModule } from '@Modules/options_module';
import { ScreenManager } from '../screen-manager';

export class ModalTemplate extends Template {
  private bootstrapModal: Modal | null = null;
  private Logger: Logger = LoggerService.createLogger('ModalTemplate');
  constructor() {
    super();
    this.html = UIModule.HTML.modal;
    this.logoUrl = OptionsModule.Options.ui.logo;
    this.Logger.trace('****  CTOR ****');
  }

  public showTemplate(): void {
    this.Logger.trace('showTemplate', 'ModalTemplate');
    if (this.isVisible) {
      this.Logger.trace('Modal already visible, not showing again.');
      return;
    }
    this.bootstrapModal?.show();
    this.isVisible = true;
  }

  public closeTemplate(): void {
    if (!this.bootstrapModal) {
      //this.Logger.error("Bootstrap modal is not initialized.");
      return;
    }
    this.bootstrapModal.hide();
    this.isVisible = false;
  }

  protected renderTemplate(): void {}

  renderBaseTemplate(): void {
    super.renderBaseTemplate();
    this.Logger.trace('renderTemplate');
    document.body.appendChild(this.container);
    const modalImg = this.container.querySelector('.mng-modal-logo');
    if (modalImg) {
      modalImg.setAttribute('src', OptionsModule.Options.ui.logo);
    }

    this.bootstrapModal = new Modal(UI_CONST.modalId, {
      backdrop: 'static',
      keyboard: false,
    });
    const myModalEl = document.querySelector(UI_CONST.modalId);
    this.Logger.trace('myModalEl', myModalEl);
    if (myModalEl) {
      myModalEl.addEventListener('hide.bs.modal', (event) => {
        this.Logger.trace('Modal hidden', event);
        this.isVisible = false;
        ScreenManager.Instance.CurrentScreen.close();
      });
    }
  }
}
